import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ConfigService from "common/services/configurations/ConfigService";
import DevicesService from "common/services/devices/DevicesService";

/** Async Thunks */

export const getConfig = createAsyncThunk("device/getConfig", async (configId) => {
  try {
    console.log("CONFIGID: ", configId)
    const response = await ConfigService.getById(configId);
    return response.data;
  } catch (error) {
    console.log("Error fetching device configuration: ", error);
    throw error;
  }
});

export const fetchTelemetries = createAsyncThunk("device/getTelemetriesList", async (deviceId) => {
  try {
    const response = await DevicesService.listTelemetries(deviceId);
    return response.data;
  } catch (error) {
    console.log(error);
  }
})

export const getDeviceData = createAsyncThunk("gateways/getData", async ({ gatewayId, deviceId }, { rejectWithValue }) => {
  try {
    const response = await DevicesService.getGateway(gatewayId);
    const gateway = response.data;
    const devices = gateway.devices || [];
    const synopticValues = {};
    const idx = devices.findIndex(e => e.id === deviceId);
    if (idx === -1) {
      console.log("Device not found")
      rejectWithValue("Device not found");
    }
    const device = devices[idx];
    const snapshot = gateway.snapshots?.[device.id] ? gateway.snapshots[device.id] : {};

    const deviceConfigTemp = await ConfigService.getById(device.configId);
    if (deviceConfigTemp.data.mainPage.synoptic) {
      const synoptic = deviceConfigTemp.data.mainPage.synoptic;
      const keySynoptic = synoptic.map(item => item.val);
      const filteredSnapshot = Object.keys(snapshot).filter(key => keySynoptic.includes(key));
      filteredSnapshot.forEach(key => {
        synopticValues[key] = snapshot[key];
      })
    }

    return { device, snapshot, logState: gateway.logState, gatewayId, synopticValues };
  } catch (error) {
    console.log(error)
    return rejectWithValue(error);
  }
});

/** Initial State */

const initialState = {
  current: null,
  config: null,
  online: true,
  regSynoptic: null,
  logEnabled: true,
  passthrough: false,
  telemetries: [],
};

/** Slice */

export const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    deviceTelemetryReceived: (state, action) => {
      const deviceId = action.payload.deviceId; 
      const regListSinottici = [];

      // Assume che state.regSinottico sia un oggetto Proxy
      const proxyObject = state.regSynoptic;

      // Verifica che state.regSynoptic non sia null o undefined
      if (proxyObject !== null && proxyObject !== undefined) {
        // Ottieni le chiavi dell'oggetto Proxy
        Object.keys(proxyObject).map(key => {
          const value = proxyObject[key];
          
          // Se il valore � un oggetto, esplora le sue propriet�
          if (typeof value === 'object' && value !== null) {
            Object.keys(value).map(nestedKey => {
              const nestedValue = value[nestedKey];
              if (nestedKey == 'val') {
                regListSinottici.push({value: nestedValue});
              }
              //console.log(`Property: ${key}.${nestedKey}, Value: ${nestedValue}`);
              return null;
            });
          }

          return null;
        });
      }

      
      if (!state.current) {
        return;
      }

      if (deviceId === state.current.id) {
        Object.values(action.payload.metrics).map(metric => {
          
          if (regListSinottici.some(item => item.value === metric.id)) {
            
            state.current.regSynoptic[metric.id] = metric.value;
          }
          state.current.data[metric.id] = metric.value;
        });
      }
      state.current.lastUpdate = action.payload.ts;
    }
  },    
  extraReducers: builder => {
    builder.addCase(getConfig.fulfilled, (state, action) => {
      state.config = action.payload;
      state.regSynoptic = state.config.mainPage.synoptic;
    });
    builder.addCase(getDeviceData.fulfilled, (state, action) => {
      if (action.payload.snapshot) {
        state.current = {
          ...action.payload.device, 
          gatewayId: action.payload.gatewayId, 
          data: action.payload.snapshot, 
          regSynoptic: action.payload.synopticValues || null,
        };
      }
      state.logEnabled = Boolean(action.payload.logState === "enabled");
      state.online = Boolean(action.payload.device.status === "online");
      state.telemetries = [];
    });

    builder.addCase(fetchTelemetries.fulfilled, (state, action) =>{
      state.telemetries = action.payload;
    });

    builder.addCase('gateways/deviceStatusUpdated', (state, action) => {
      if (state.current) {
        // Check log state and passthrough mode
        const gatewayState = action.payload.body;
        if (action.payload.id === state.current.gatewayId ) {
          if ("appState" in gatewayState) {
            state.passthrough = Boolean(gatewayState.appState === "passthrough")
          }
          if ("logState" in gatewayState) {
            state.logEnabled = Boolean(gatewayState.logState === "enabled")
          } 
        }

        if (gatewayState?.devices) {
          const timestamp = action.payload.ts;
          const updatedDevices = action.payload.body.devices;
          const currentId = state.current?.id;
          if (currentId && currentId in updatedDevices) {
            if (updatedDevices[currentId].status) {
              state.current.status = updatedDevices[currentId].status;
              state.online = Boolean(updatedDevices[currentId].status === "online")
            }
            state.current.lastUpdate = timestamp;
          }
        }
      }
    });
  },
});

export const { deviceTelemetryReceived } = deviceSlice.actions;
export default deviceSlice.reducer;